export default {
    // ******************************************
    // Globals
    // ******************************************
    global_brand_name: "Rosetta Stone",
    product_name: "Rosetta Stone",

    // ******************************************
    // Globals - Locales
    // ******************************************
    locale_ar_ar_label_primary: "Árabe",
    locale_ar_ar_label_secondary: "",
    locale_de_de_label_primary: "Alemán",
    locale_de_de_label_secondary: "",
    locale_el_gr_label_primary: "Griego",
    locale_el_gr_label_secondary: "",
    locale_en_gb_label_primary: "Inglés",
    locale_en_gb_label_secondary: "",
    locale_en_us_label_primary: "Inglés",
    locale_en_us_label_secondary: "Americano",
    locale_es_es_label_primary: "Español",
    locale_es_es_label_secondary: "España",
    locale_es_la_label_primary: "Español",
    locale_es_la_label_secondary: "Latinoamérica",
    locale_fa_ir_label_primary: "Persa",
    locale_fa_ir_label_secondary: "Farsi",
    locale_fr_fr_label_primary: "Francés",
    locale_fr_fr_label_secondary: "",
    locale_ga_ie_label_primary: "Irlandés",
    locale_ga_ie_label_secondary: "",
    locale_he_il_label_primary: "Hebreo",
    locale_he_il_label_secondary: "",
    locale_hi_in_label_primary: "Hindi",
    locale_hi_in_label_secondary: "",
    locale_it_it_label_primary: "Italiano",
    locale_it_it_label_secondary: "",
    locale_ja_jp_label_primary: "Japonés",
    locale_ja_jp_label_secondary: "",
    locale_ko_kr_label_primary: "Coreano",
    locale_ko_kr_label_secondary: "",
    locale_la_va_label_primary: "Latin",
    locale_la_va_label_secondary: "",
    locale_nl_nl_label_primary: "Holandés",
    locale_nl_nl_label_secondary: "",
    locale_pl_pl_label_primary: "Polaco",
    locale_pl_pl_label_secondary: "",
    locale_pt_br_label_primary: "Portugués",
    locale_pt_br_label_secondary: "",
    locale_ru_ru_label_primary: "Ruso",
    locale_ru_ru_label_secondary: "",
    locale_sv_se_label_primary: "Sueco",
    locale_sv_se_label_secondary: "",
    locale_tl_ph_label_primary: "Filipino",
    locale_tl_ph_label_secondary: "",
    locale_tr_tr_label_primary: "Turco",
    locale_tr_tr_label_secondary: "",
    locale_vi_vn_label_primary: "Vietnamita",
    locale_vi_vn_label_secondary: "",
    locale_zn_cn_label_primary: "Chino",
    locale_zn_cn_label_secondary: "Mandarin",

    // ******************************************
    // Nav Primary
    // ******************************************
    nav_primary_blog_label: "Blog",
    nav_primary_catalog_label: "Idiomas Y Precios",
    nav_primary_catalog_select_language_label: "Selecciona un idioma:",
    nav_primary_contact_label: "",
    nav_primary_logo_alt: "Rosetta Stone",
    nav_primary_phone_label: "¿Preguntas? Llámenos",
    nav_primary_phone_number: "1 (800) 511-5689",
    nav_primary_sign_in_label: "INGRESAR",
    nav_primary_support_label: "Soporte",
    nav_primary_switch_language: "English",
    nav_primary_vertical_consumer_label: null,
    nav_primary_vertical_education_for_homeschool_label: "",
    nav_primary_vertical_education_for_students_label: "Para Estudiantes",
    nav_primary_vertical_education_homeschool_label: null,
    nav_primary_vertical_education_primary_label: "Para Educadores",
    nav_primary_vertical_education_secondary_label: "",
    nav_primary_vertical_education_students_label: "",
    nav_primary_vertical_enterprise_label: "Para Empresa",
    nav_primary_vertical_for_young_learners_label: "",

    // ******************************************
    // Nav Secondary - Enterprise
    // ******************************************
    nav_secondary_enterprise_blog_label: "Blog",
    nav_secondary_enterprise_custom_1_label: "Quiero ser Partner",
    nav_secondary_enterprise_home_label: "Inicio",
    nav_secondary_enterprise_label: "Empresa",
    nav_secondary_enterprise_resources_label: "Recursos",
    nav_secondary_enterprise_solutions_label: "Soluciones",

    // Solutions

    // ******************************************
    // Nav Secondary - Education Primary
    // ******************************************
    nav_secondary_education_primary_blog_label: "Blog",
    nav_secondary_education_primary_custom_1_label: "Quiero ser Partner",
    nav_secondary_education_primary_home_label: "Inicio",
    nav_secondary_education_primary_label: "Educación",
    nav_secondary_education_primary_resources_label: "Recursos",
    nav_secondary_education_primary_solutions_label: "Soluciones",

    // ******************************************
    // Nav Secondary - Education Secondary
    // ******************************************
    nav_secondary_education_secondary_blog_label: "Blog",
    nav_secondary_education_secondary_custom_1_label: "Quiero ser Partner",
    nav_secondary_education_secondary_home_label: "Inicio",
    nav_secondary_education_secondary_label: "Educación Superior",
    nav_secondary_education_secondary_resources_label: "Recursos",
    nav_secondary_education_secondary_solutions_label: "Soluciones",

    // ******************************************
    // Nav Secondary - Education Homeschool
    // ******************************************
    nav_secondary_education_homeschool_blog_label: "",
    nav_secondary_education_homeschool_home_label: "",
    nav_secondary_education_homeschool_label: "",
    nav_secondary_education_homeschool_resources_label: "",
    nav_secondary_education_homeschool_solutions_label: "",

    // ******************************************
    // Nav Secondary - Services
    // ******************************************
    nav_secondary_services_blog_label: "",
    nav_secondary_services_home_label: "",
    nav_secondary_services_label: "",
    nav_secondary_services_resources_label: "",
    nav_secondary_services_solutions_label: "",

    // ******************************************
    // Shared - Awards
    // ******************************************
    awards_header_label: "Avalada durante 25+ años por las mejores organizaciones.",
    awards_bmw: "BMW",
    awards_ikea: "Ikea",
    awards_lego: "Lego",
    awards_twitter: "Twitter",
    awards_uber: "Uber",
    awards_williams_sonoma: "Williams Sonoma",

    // ******************************************
    // Shared - Branded Quotes
    // ******************************************
    branded_quotes_header_label: "Qué dice la gente de nosotros.",
    branded_quotes_cnn_name: "CNN",
    branded_quotes_cnn_quote:
        "&quot;<em>La joya de la corona</em>entre los métodos de aprendizaje de idiomas por ordenador.&quot;",
    branded_quotes_cnn_type: "cnn",

    branded_quotes_macworld_name: "MacWorld",
    branded_quotes_macworld_quote:
        "&quot;”Me encanta el programa de Rosetta Stone y creo que su método para <em>aprender idiomas funciona.</em>&quot;",
    branded_quotes_macworld_type: "macworld",

    branded_quotes_techcrunch_name: "TechCrunch",
    branded_quotes_techcrunch_quote:
        "&quot; “Con su interfaz excelente para el usuario, instrucciones claras y una amplia gama de juegos y retos...  <em>Rosetta Stone sorprende.</em>&quot;",
    branded_quotes_techcrunch_type: "techcrunch",

    // ******************************************
    // Shared - Related Resources
    // ******************************************
    related_resources_label: "",
    related_resources_button_label: "",

    // ******************************************
    // Shared - Verticals
    // ******************************************
    verticals_label: "¿Qué tipo de aprendiz eres?",
    verticals_education_primary: "Educación",
    verticals_education_secondary: "Educación Superior ",
    verticals_enterprise: "Empresa",
    verticals_publicsector: "",

    // ******************************************
    // Footer
    // ******************************************
    // CTA Form
    footer_cta_email_button: "Sign Up",
    footer_cta_email_main_label: "Sign up to stay in touch.",
    footer_cta_email_placeholder: "Sign Up",
    footer_cta_email_sub_label: "Get Rosetta Stone news and offers.",
    footer_cta_form_comments: "",
    footer_cta_form_country: "País",
    footer_cta_form_email: "E-mail profesional",
    footer_cta_form_firstname: "Nombre",
    footer_cta_form_lastname: "Apellidos",
    footer_cta_form_organization: "Nombre de la Organización",
    footer_cta_form_organizationsize: "Tamaño de la organización",
    footer_cta_form_organizationsize_100: "100 o Menos",
    footer_cta_form_organizationsize_500: "101 - 500",
    footer_cta_form_organizationsize_1000: "501 - 1,000",
    footer_cta_form_organizationsize_5000: "1,001 - 5,000",
    footer_cta_form_organizationsize_10000: "5,001 - 10,000",
    footer_cta_form_organizationsize_25000: "10,001 - 25,000",
    footer_cta_form_organizationsize_50000: "25,001 - 50,000",
    footer_cta_form_organizationsize_more: "50,001 - Más",
    footer_cta_form_phone: "Numero de Teléfono (Opcional)",
    footer_cta_form_pricing_thanks: "¡Gracias por tu interés! Alguien hará un seguimiento contigo en breve.",
    footer_cta_form_role: "Rol (o título)",
    footer_cta_form_role_boardmember: "Miembro de la Junta",
    footer_cta_form_role_curriculumdirector: "Director de Currículo / Coordinador de Instrucción",
    footer_cta_form_role_director: "Director",
    footer_cta_form_role_executive: "Dirección General / Ejecutivo",
    footer_cta_form_role_individualcontributor: "Colaborador Individual",
    footer_cta_form_role_manager: "Gerente",
    footer_cta_form_role_principal: "Director de la Escuela",
    footer_cta_form_role_superintendent: "Superintendente / Administrador de Distrito",
    footer_cta_form_role_teacher: "Profesor",
    footer_cta_form_role_techcoordinator: "Coordinador de Tecnologia",
    footer_cta_form_role_vicepresident: "Vicepresidente",
    footer_cta_form_submit: "Consulta gratuita",
    footer_cta_how_hear_blog: "Blog",
    footer_cta_how_hear_email: "Email",
    footer_cta_how_hear_event: "Evento",
    footer_cta_how_hear_online: "En línea",
    footer_cta_how_hear_other: "Otro",
    footer_cta_how_hear_referral: "Remisión",
    footer_cta_how_hear_search: "Buscador",
    footer_cta_how_hear_social: "Medios Sociales",
    footer_cta_how_hear_title: "¿Como supiste de nosotros? (Opcional)",
    footer_cta_how_hear_webinar: "Seminario Web",
    footer_cta_opt_in_learn_more_button_text: " aquí",
    footer_cta_opt_in_learn_more_link_text_1: "aquí.",
    footer_cta_opt_in_learn_more_privacyemail: " privacyofficer@rosettastone.com",
    footer_cta_opt_in_learn_more_privacyUrl: "https://resources.rosettastone.com/CDN/es/pdfs/Spain_Privacy_Policy.pdf",
    footer_cta_opt_in_learn_more_text_1:
        "Rosetta Stone se compromete a proteger su privacidad. Nuestra completa política de privacidad está disponible ",
    footer_cta_opt_in_learn_more_text_2: " privacyofficer@rosettastone.com",
    footer_cta_opt_in_learn_more_text_3: ".",
    footer_cta_opt_in_text_after_button: "para más información.",
    footer_cta_opt_in_text_before_button:
        "¡Sí! Me gustaría recibir actualizaciones de productos y marketing de Rosetta Stone. Haga clic",
    footer_cta_pricing_button: "CONSULTA DE PRECIOS",
    footer_cta_pricing_label: "Listo para el siguiente paso?",
    footer_cta_pricing_subtitle: "Por favor complete y nos pondremos en contacto con usted de inmediato.",
    footer_cta_pricing_thanks: "",
    footer_cta_pricing_title: "Obtenga las respuestas de precios que necesita.",

    // Menu
    footer_menu_about_about_us_label: "Acerca de Nosotros",
    footer_menu_about_blog_label: "Blog",
    footer_menu_about_careers_label: "Empleo",
    footer_menu_about_contact_label: "Contáctanos",
    footer_menu_about_endangered_languages_label: "Idiomas en peligro de extinción",
    footer_menu_about_investor_relationss_label: "Investor Relations",
    footer_menu_about_investors_label: "Relaciones con Inversores",
    footer_menu_about_k12_reading_label: "Reading Solutions for K–12",
    footer_menu_about_label: "Acerca de",
    footer_menu_about_military_discount_label: "Descuento militar",
    footer_menu_about_press_label: "Prensa",
    footer_menu_about_retail_partners_label: "Tiendas Retail",
    footer_menu_about_student_discount_label: "Student Discount",
    footer_menu_buy_all_label: "Ver todos los idiomas",
    footer_menu_buy_chinese_label: "Comprar Chino",
    footer_menu_buy_english_label: "Comprar Inglés",
    footer_menu_buy_espanol_label: "Rosetta Stone Español",
    footer_menu_buy_french_label: "Comprar Francés",
    footer_menu_buy_german_label: "Comprar Alemán",
    footer_menu_buy_homeschool_label: "Rosetta Stone Homeschool",
    footer_menu_buy_ingles_label: "Inglés",
    footer_menu_buy_italian_label: "Comprar Italiano",
    footer_menu_buy_japanese_label: "Comprar Japonés",
    footer_menu_buy_label: "Comprar Idiomas",
    footer_menu_buy_spanish_label: "Comprar Español",
    footer_menu_gift_label: "Regalos",
    footer_menu_learn_chinese_label: "Learn Chinese",
    footer_menu_learn_english_label: "Aprender Ingles",
    footer_menu_learn_french_label: "Aprender Francés",
    footer_menu_learn_german_label: "Aprender Alemán",
    footer_menu_learn_ingles_label: "Aprende Inglés",
    footer_menu_learn_italian_label: "Aprender Italiano",
    footer_menu_learn_japanese_label: "Learn Japanese",
    footer_menu_learn_label: "Aprender Idiomas",
    footer_menu_learn_languages_label: "Learn a Language",
    footer_menu_learn_portuguese_label: "Aprender Portugués",
    footer_menu_products_demo_label: "Pruébalo gratis",
    footer_menu_products_education_primary_label: "Para Educadores",
    footer_menu_products_education_secondary_label: "Para Educadores Superiores",
    footer_menu_products_enterprise_label: "Para Empresa",
    footer_menu_products_label: "¿DÓNDE EMPEZAR?",
    footer_menu_products_mobile_label: "Apps para móvil",
    footer_menu_products_reviews_label: "Opiniones",
    footer_menu_start_activation_label: "Product Activation",
    footer_menu_start_blog_label: "Blog",
    footer_menu_start_demo_label: "Pruébalo Gratis",
    footer_menu_start_education_primary_label: "For Schools",
    footer_menu_start_enterprise_label: "For Enterprise",
    footer_menu_start_label: "Donde comenzar",
    footer_menu_start_mobile_label: "Aplicaciones Móviles",
    footer_menu_start_reviews_label: "Comentarios sobre Rosetta Stone",
    footer_menu_start_speech_label: "Speech Recognition",
    footer_menu_start_testamonials_label: "Testimonios de Rosetta Stone",
    footer_menu_start_translate_label: "Traduce Ahora",
    footer_menu_support_accessibility_statement_label: "Accessibility Statement",
    footer_menu_support_contact_us_label: "Contáctenos",
    footer_menu_support_faqs_label: "Preguntas Frecuentes",
    footer_menu_support_label: "Soporte",
    footer_menu_support_support_site_label: "Soporte Técnico",
    footer_menu_support_system_requirements_label: "Requisitos del sistema",

    // Meta
    footer_meta_agreements_label: "Acuerdos",
    footer_meta_ccpa_label: "Do Not Sell My Information",
    footer_meta_cookie_settings_label: "Configuración de Cookie",
    footer_meta_copyright_alt: "Go to home page",
    footer_meta_copyright_IXL: "A division of IXL Learning",
    footer_meta_copyright_label: "Rosetta Stone Ltd. Todos los derechos reservados.",
    footer_meta_privacy_policy_label: "Política de Privacidad",
    footer_meta_terms_conditions_label: "Términos y Condiciones",

    // Region
    footer_region_label: "Cambiar Región",
    footer_region_options_au_label: "Australia",
    footer_region_options_br_label: "Brasil",
    footer_region_options_cn_label: "中国",
    footer_region_options_de_label: "Deutschland",
    footer_region_options_es_label: "España",
    footer_region_options_eu_label: "Europe",
    footer_region_options_fr_label: "France",
    footer_region_options_it_label: "Italia",
    footer_region_options_jp_label: "日本",
    footer_region_options_kr_label: "대한민국",
    footer_region_options_la_label: "America Latina",
    footer_region_options_uk_label: "United Kingdom",
    footer_region_options_us_label: "United States",

    // Social
    footer_social_label: "Conéctate con nosotros",
    footer_social_facebook_alt: "Facebook",
    footer_social_instagram_alt: "Instagram",
    footer_social_twitter_alt: "Twitter",
    footer_social_youtube_alt: "Youtube"
};
